import {importFile, req} from './axiosFun';
/**
 * 订单管理
 **/
// 商品订单列表
export const qryOrderList = (params) => { return req("post", "/yishantong-ui/order/qryOrderList", params) };

// 订单查验中心
export const qryOrderStatusList = (params) => { return req("post", "/yishantong-ui/order/qryOrderStatusList", params) };

// 订单查验状态修改
export const upRefundOrderStatus = (params) => { return req("post", "/yishantong-ui/order/upRefundOrderStatus", params) };
// 押金退款分页
export const qryRefundList = (params) => { return req("post", "/yishantong-ui/order/qryRefundList", params) };

// /订单申请押金退款
export const upOrderStatus = (params) => { return req("post", "/yishantong-ui/order/upOrderStatus", params) };
export const fpOrder = (params) => { return req("post", "/yishantong-ui/order/fpOrder", params) };

// /订单押金退款
export const upCashStatus = (params) => { return req("post", "/yishantong-ui/order/upCashStatus", params) };



// /财务复核管理分页
export const qryFhList = (params) => { return req("post", "/yishantong-ui/order/qryFhList", params) };
// /财务复核状态修改
export const upFhStatus = (params) => { return req("post", "/yishantong-ui/order/upFhStatus", params) };
// 导出复核信息
export const downloadFhExcel = (params) => { return importFile("post", "/yishantong-ui/order/downloadFhExcel", params) };
// 导出押金退款信息
export const downloadRefundExcel = (params) => { return importFile("post", "/yishantong-ui/order/downloadRefundExcel", params) };
// 导出订单信息
export const downloadOrderExcel = (params) => { return importFile("post", "/yishantong-ui/order/downloadOrderExcel", params) };
















// WEBPACK FOOTER //
// ./src/api/convenience.js